import { TawkAPI } from '../../types';
import { isClient } from '../constants';
import { whenIdle } from '../loadAssets';

declare global {
  interface Window {
    Tawk_API: TawkAPI;
    Tawk_LoadStart: Date;
  }
  var Tawk_API: TawkAPI;
}

let hideWidget = false;

if (isClient) {
  window.Tawk_API = window.Tawk_API || ({} as TawkAPI);

  window.Tawk_API.onBeforeLoad = function () {
    if (!isClient) return;
    // to ensure it is still hidden if hide tawk to was called before the widget loads
    if (hideWidget) hideTawkTo();
  };
}

export function loadTawkTo() {
  // The idle load and an early Live Chat click can both ask; the second is a no-op.
  if (window.Tawk_LoadStart) return;
  window.Tawk_LoadStart = new Date();
  let s1 = document.createElement('script'),
    s0 = document.getElementsByTagName('script')[0];
  s1.async = true;
  s1.src = 'https://embed.tawk.to/57a890a50e299d9644791219/default';
  s1.charset = 'UTF-8';
  s1.setAttribute('crossorigin', '*');
  s0.parentNode?.insertBefore(s1, s0);
}

/** Once the page has loaded and gone idle, so the chat never competes with what the visitor came for. */
export const loadTawkToWhenIdle = () => whenIdle(loadTawkTo);

/** Toggles the chat; before it is ready, starts loading it and retries until it can open. */
export function openTawkTo() {
  if (window.Tawk_API.toggle) return window.Tawk_API.toggle();

  loadTawkTo();
  let tries = 0;
  const retry = setInterval(() => {
    if (window.Tawk_API.maximize) window.Tawk_API.maximize();
    // 15s: an ad blocker can stop the chat from ever loading.
    else if (++tries < 60) return;
    clearInterval(retry);
  }, 250);
}

export function hideTawkTo() {
  hideWidget = true;
  //   window.Tawk_API.hideWidget?.();
  window.Tawk_API.shutdown?.();
}

export function showTawkTo() {
  hideWidget = false;
  window.Tawk_API.showWidget?.();
}
